<template>
    <q-space/>
</template>

<script>
import uiControlMixin from 'src/mixins/ui/uiControlMixin';

export default {
    name: 'Space',
    mixins: [uiControlMixin],
    computed: {
        height () {
            return this.params.height || 0;
        },
    },
};
</script>

<style scoped>

</style>
